export default "__VITE_ASSET__0f135ef5__"